import React from 'react';
import classNames from 'classnames';

import PropTypes from 'prop-types';

class ToggleComponent extends React.Component {
  constructor(props) {
    super(props);
    let checked = false;
    if ('checked' in this.props) {
      checked = this.props.checked;
    } else if ('defaultChecked' in this.props) {
      checked = this.props.defaultChecked;
    }
    this.state = {
      checked: !!checked,
      hasFocus: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  componentDidMount() {
    const checkbox = this.refs.input;
    checkbox.checked = this.state.checked;
  }

  componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({ checked: !!nextProps.checked });
    } else if ('defaultChecked' in this.props) {
      this.setState({ checked: nextProps.defaultChecked });
    }
    const checkbox = this.refs.input;
    checkbox.checked = this.state.checked;
  }

  handleBlur() {
    this.setState({ hasFocus: false });
  }

  handleClick(event) {
    const checkbox = this.refs.input;
    if (event.target !== checkbox) {
      event.preventDefault();
      checkbox.focus();
      checkbox.click();
      return;
    }
    this.props.handleClick(!this.state.checked);
  }

  handleFocus() {
    this.setState({ hasFocus: true });
  }

  render() {
    let classes = classNames('react-toggle', {
      'react-toggle--checked': this.state.checked,
      'react-toggle--focus': this.state.hasFocus,
      'react-toggle--disabled': this.props.disabled,
    });
    return (
      <div className="toggleswitch">
        <p className="type--bute togglestatus">OFF ON</p>
        <div className={classes} onClick={this.handleClick}>
          <div className="react-toggle-track" />
          <div className="react-toggle-thumb" />
          <input
            ref="input"
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            className="react-toggle-screenreader-only"
            type="checkbox"
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

ToggleComponent.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  'aria-labelledby': PropTypes.string,
  'aria-label': PropTypes.string,
  disabled: PropTypes.bool,
};

ToggleComponent.propTypes = {
  handleClick: PropTypes.func,
};

ToggleComponent.defaultProps = {};

export default ToggleComponent;
